// Utility to clear cookies. Note: HttpOnly cookies cannot be cleared from JS.
export function clearAllCookies() {
    // Clear standard cookies by setting expiry in the past for all paths and domains
    const cookies = document.cookie.split(';').map(c => c.trim()).filter(c => c.length);
    for (const cookie of cookies) {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        // Set cookie for current path/domain
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        // Try to clear with domain variations
        try {
            const hostParts = location.hostname.split('.');
            for (let i = 0; i < hostParts.length - 1; i++) {
                const domain = '.' + hostParts.slice(i).join('.');
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
            }
        } catch (e) {
            // ignore
        }
    }
}

export function clearStorages() {
    try { localStorage.clear(); } catch (e) {}
    try { sessionStorage.clear(); } catch (e) {}
}

// Utility for cookie helpers
// Cookie 删除必须匹配写入时的 domain/path；仅清理登录凭证，保留访客标识等数据。
export function clearAuthCookies() {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    const { hostname, pathname } = window.location;
    const domains = new Set<string>(['']);
    const hostParts = hostname.split('.');
    for (let i = 0; i < hostParts.length; i++) {
        if (i > 0 && i === hostParts.length - 1) break;
        const domain = hostParts.slice(i).join('.');
        domains.add(domain);
        domains.add(`.${domain}`);
    }
    const paths = new Set(['/', '/vivo', '/vivo/', '/vivo-pc', '/vivo-pc/']);
    // 包含当前路径及其父路径，兼容未显式设置 Path 的历史 Cookie。
    const segments = pathname.split('/').filter(Boolean);
    segments.forEach((_, index) => {
        const path = `/${segments.slice(0, index + 1).join('/')}`;
        paths.add(path);
        paths.add(`${path}/`);
    });
    for (const name of ['access_token', 'user_code']) {
        for (const domain of Array.from(domains)) {
            for (const path of Array.from(paths)) {
                deleteCookie(name, { path, domain });
            }
        }
    }
}

export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

export function deleteCookie(name: string, options: { path?: string; domain?: string } = {}) {
    const path = options.path || '/';
    const domain = options.domain ? `;domain=${options.domain}` : '';
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}${domain}`;
}
